import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isClickHit } from '../../store/apiWrapper';
import { registerHook, isClickTo, unregisterHook } from '../../store/clickWrapper';
import PropTypes from 'prop-types';

import "./moreButton.scss";

class MoreButton extends Component {
    state = {
        expanded: false
    }
    mounted = false;
    render() {
        return (
            <div className="more-button">
                <div className="btn-wrap" onClick={() => this.setState({ expanded: !this.state.expanded })}>
                    <FontAwesomeIcon icon="ellipsis-v" className='svg-standard-color' />
                </div>

                {this.state.expanded &&
                    <div className="more-button-items" ref={el => this.items = el} id={this.props.id} style={this.getStyle()} onMouseOut={(e) => this.handleMouseOut(e)} >
                        <div className="items">
                            {this.props.children}
                        </div>
                    </div>
                }
            </div>
        )
    }
    getStyle = () => {
        if (this.props.mode === "rightAligned") {
            return { left: `calc(-${this.props.contentWidth}px + 2em)`, width: `${this.props.contentWidth}px` }
        }
        if (this.props.mode === "leftAligned") {
            return { left: `0px`, width: `${this.props.contentWidth}px` }
        }
        if (this.props.mode === "centered") {
            return { left: `calc(-${this.props.contentWidth}px / 2 + 1em)`, width: `${this.props.contentWidth}px` }
        }
    }
    handleMouseOut = (e) => {
        if (!isClickHit(document.querySelector(`#${this.props.id}`), e)) {
            this.setState({ expanded: false });
        }
    }
    componentDidMount() {
        this.mounted = true;
        this.hookId = registerHook(this, (click) => {
            if (this.state.expanded && !isClickTo(click, [this.items]) && this.mounted) {
                this.setState({ expanded: false });
            }
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        unregisterHook(this.hookId);
    }
}

MoreButton.propTypes = {
    mode: PropTypes.oneOf(["leftAligned", "centered", "rightAligned"]).isRequired,
    contentWidth: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired
}
export default MoreButton;
